import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class FeedbackForm extends BaseComponent {
	
	static get properties() {
		return {
			type: {type: String},
			style: {type: String},
			summary: {type: String},
			descriptionPlaceHolder: {type: String},
			hideType: {type: Boolean},
			hideSummary: {type: Boolean},
			extraDetail: {type: String}
		};
	}
	
	constructor() {
		super();
				
		
		var feedbackForm = this;
		setTimeout(function(){
			feedbackForm.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var feedbackForm = this;

		var formPanel = ElementUtil.create({
			tag: 'dl-form-panel',
			style: feedbackForm.style,
			itemid: 'form',
			children: [
				{
					tag: 'vaadin-form-layout',										
					children: [
						{
							tag: 'vaadin-combo-box',
							itemid: 'type',
							label: 'Type',
							name: 'ticketType',
							'item-value-path': 'code',
							'item-label-path': 'desc',
							'prevent-invalid-input': true,
							postinit: function(combo) {							
								combo.items = [
									{
										code: 'Help',
										desc: 'Help'
									}, 
									{
										code: 'Suggestion',
										desc: 'Suggestion'
									}, 
									{
										code: 'Application Issue',
										desc: 'Application Issue'
									}
								];
								combo.value = feedbackForm.type ? feedbackForm.type : 'Help';
							}
						},
						{
							tag: 'vaadin-text-field',
							itemid: 'summary',
							name: 'summary',
							label: 'Summary',
							required: true,
							maxlength: 255,
							value: feedbackForm.summary ? feedbackForm.summary : '',
							colspan: 2
						},
						{
							tag: 'vaadin-text-area',
							label: 'Description',
							name: 'description',
							style: 'min-height: 12em; max-height: 32em;',
							placeholder: feedbackForm.descriptionPlaceHolder ? feedbackForm.descriptionPlaceHolder : '',
							required: true,
							maxlength: 1024,
							colspan: 2
						},
						{
							tag: 'hr',
							colspan: 2
						},
						{
							tag: 'div',
							style: 'text-align: center;',
							colspan: 2,
							defaults: {
								tag: 'vaadin-button'
							},
							children: [
								{
									theme: 'primary',
									children: [
										ElementUtil.makeIcon('vaadin:database', ' Submit')
									],
									listeners: {
										click: function() {															

											if (formPanel.isValid()) {

												var data = formPanel.getData();	
												
												if (feedbackForm.extraDetail) {
													data.description += '<br><br>' + feedbackForm.extraDetail;
												}
												
												Service.getCompanyService().getCurrentCompany()
														.then(function(fullCompany){
															data.companyName = fullCompany.company.companyName;
															data.companyId = fullCompany.company.companyId;
															
															Service.getUserService().getCurrentUser().then(function(user){
																data.username = user.userId;
																data.firstname = user.firstname;
																data.lastname = user.lastname;

																//web info
																data.webInformation = {
																	location: window.location.href,
																	userAgent: navigator.userAgent,
																	referrer: document.referrer,
																	screenResolution: window.screen.availWidth + 'x' + window.screen.availHeight
																};


																var loadMask = formPanel.showLoading('Submitting Feedback...');
																Service.getFeedbackService().postFeedback(data).then(function(result){
																	loadMask.remove();

																	var actionEvent = new CustomEvent('success', { detail: '' });
																	feedbackForm.dispatchEvent(actionEvent);
																});	

															});	
															
														});																																					

											}	
										}
									}
								},
								{
									theme: 'tertiary',
									innerHTML: 'Cancel',
									style: 'margin-left: 10px;',
									listeners: {
										click: function() {
											var actionEvent = new CustomEvent('cancel', { detail: '' });
											feedbackForm.dispatchEvent(actionEvent);
										}
									}
								}
							]
						}						
						
					]
				}
			]
		});
		feedbackForm.append(formPanel);
		
		if (feedbackForm.hideType) {
			ElementUtil.query(formPanel, 'type').hidden=true;			
		}
		
		if (feedbackForm.hideSummary) {
			ElementUtil.query(formPanel, 'summary').hidden=true;			
		}
				
	}	
};
customElements.define('dl-feedback-form', FeedbackForm);
	

